import type { RegistroDiario } from '@/lib/types';

const DAY_MS = 86_400_000;

export function partReference(
  registros: RegistroDiario[] | undefined,
  fecha: string,
  entrada: string,
) {
  if (!registros)
    return { yesterday: null, mean: null, count7: 0, cumulative: null, missing: null };

  const before = new Map(
    registros
      .filter((record) => record.fecha >= entrada && record.fecha < fecha)
      .map((record) => [record.fecha, record.bajas_muerte + record.bajas_triaje]),
  );
  const date = Date.parse(`${fecha}T00:00:00Z`);
  const previous = Array.from({ length: 7 }, (_, index) =>
    before.get(new Date(date - (index + 1) * DAY_MS).toISOString().slice(0, 10)),
  );
  const count7 = previous.filter((value) => value !== undefined).length;
  const days = Math.max(0, Math.round((date - Date.parse(`${entrada}T00:00:00Z`)) / DAY_MS));
  return {
    yesterday: previous[0] ?? null,
    mean: count7 === 7 ? previous.reduce<number>((sum, value) => sum + (value ?? 0), 0) / 7 : null,
    count7,
    cumulative: [...before.values()].reduce((sum, value) => sum + value, 0),
    missing: Math.max(0, days - before.size),
  };
}
